const styleObject = {
  tableContainer: {},
  filtersContainer: {},
  paginationContainer: {
    marginTop: '5vh',
    display: 'flex',
    justifyContent: 'center'
  }
}

export default styleObject
